import { Link } from "react-router-dom";
import { ArrowLeft, GhostIcon, House } from "@phosphor-icons/react";
import { PageHeader } from "../components/PageHeader";

export const NotFoundPage = () => {
    return (
        <div data-testid="notfound-page">
            <PageHeader
                eyebrow="404 · Lost in the stream"
                title="This corner doesn't"
                accent="exist."
                intro="Either the stream's down or the URL was a typo. Either way, let's get you back to base."
                breadcrumbs={[{ label: "Home", href: "/" }, { label: "404" }]}
            />
            <section className="py-16">
                <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
                    <GhostIcon size={64} weight="duotone" className="text-neon-purple mx-auto mb-6" />
                    <div className="flex flex-wrap items-center justify-center gap-3">
                        <Link
                            to="/"
                            className="btn-sweep inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-neon-cyan text-black text-sm font-semibold"
                            data-testid="notfound-home-btn"
                        >
                            <House size={14} weight="fill" /> Back to Home
                        </Link>
                        <Link
                            to="/live"
                            className="btn-sweep inline-flex items-center gap-2 px-5 py-2.5 rounded-full glass border border-white/10 text-white text-sm"
                            data-testid="notfound-live-btn"
                        >
                            <ArrowLeft size={14} weight="bold" /> Go to Live
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};
